import React, { type PropsWithChildren } from 'react';
import noop from 'lodash/noop';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import { AsyncBulkOpsCoreFull } from '@atlassian/jira-bulk-operations-full-core/src/async';
import { fg } from '@atlassian/jira-feature-gating';

export const BulkOperationsWrapper = ({ children }: PropsWithChildren) => {
	if (!fg('bulk_operations_in_nin')) {
		return children;
	}

	return (
		<Flex xcss={wrapperStyles} direction="row">
			<Box xcss={childContainerStyles}>{children}</Box>
			<AsyncBulkOpsCoreFull
				// TODO: these props will be wired in https://hello.jira.atlassian.cloud/browse/DEE-6327
				selectedIssueIds={[]}
				onClearAll={noop}
				onSelectAll={noop}
				onClearAllVisible={noop}
				hasBulkEditPermission
				selectableIssueIds={[]}
			/>
		</Flex>
	);
};

const wrapperStyles = xcss({
	height: '100%',
});

const childContainerStyles = xcss({
	flex: 1,
	overflowY: 'auto',
});
